import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import LoadableDeviationSubmitPopup from './modals/DeviationSubmitPopup';
export const submitModalRenderer = (modalType, requestClose, params)=>{
    switch(modalType){
        case ModalType.DEVIATION_SUBMIT:
            return /*#__PURE__*/ React.createElement(LoadableDeviationSubmitPopup, _object_spread({
                requestClose: requestClose
            }, params));
        default:
            return null;
    }
};

//# sourceMappingURL=project-tools.js.map